<div class="content-w-98">
  <div class="row">
    <div class="col-12">
      <label class="headerName">Product scenario configuration</label>
    </div>
    <div class="col-12 pt-3">
      <label class="subTitleName">Add your first product scenario</label>
    </div>
  </div>

  <ng-container>
    <form
      [formGroup]="productProjectForm"
      [ngClass]="{ 'disabled-popup': !showEdit }"
      (keydown.enter)="$event.preventDefault()"
    >
      <div class="row pt-2">
        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              label="Product name"
              name="productName"
              placeholder="Product name"
              formControlName="productName"
              [control]="productProjectForm.controls['productName']"
              [submitted]="submitted"
              [maxLength]="50"
              inputType="text"
              [required]="true"
              [preventDot]="true"
              (customBlur)="saveData($event, 'productName')"
            ></piqet-angular-common-input>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              label="Product name used in report"
              name="productNameReport"
              placeholder="Product name"
              formControlName="productNameReport"
              [control]="productProjectForm.controls['productNameReport']"
              [submitted]="submitted"
              [maxLength]="15"
              inputType="text"
              [preventDot]="true"
              (customBlur)="saveData($event)"
            ></piqet-angular-common-input>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <div class="text-icon-align d-flex">
              <p style="margin-bottom: 0px" class="h6">Quantity</p>
              <div
                placement="right"
                [ngbTooltip]="tipContent"
                tooltipClass="sku-tooltip"
                container="body"
                style="position: relative; bottom: 7px"
              >
                <a class="info-icon">
                  <span>
                    <img src="./assets/icons/grey-question-icon.svg" width="14" height="14" /></span
                ></a>
              </div>
              <ng-template #tipContent>
                <span>Enter quantity of product in the package (g or ml)</span>
              </ng-template>
            </div>
            <piqet-angular-common-input
              name="amount"
              placeholder="Quantity"
              formControlName="amount"
              [control]="productProjectForm.controls['amount']"
              [submitted]="submitted"
              [maxLength]="50"
              inputType="number"
              [preventNegative]="true"
              (customBlur)="saveData($event)"
              [errorMessages]="{
                nonNegative: 'Please enter a positive value.',
                required: 'Quantity is required'
              }"
            ></piqet-angular-common-input>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="input-div">
            <div class="text-icon-align d-flex">
              <p style="margin-bottom: 2px" class="h6">Unit</p>
            </div>
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              #unitSelect
              [items]="allProductConfigurationData?.unitList"
              (change)="saveData($event, 'isDrpDwn')"
              formControlName="unit"
              [searchable]="false"
              bindLabel="name"
              placeholder="Unit *"
              (change)="changeUnit($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="unitSelect.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
          <div
            *ngIf="
              (submitted || productProjectForm.controls['unit']?.touched) &&
              productProjectForm.controls['unit']?.invalid
            "
            class="input-error"
          >
            Unit is required.
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              name="density"
              [label]="'Density'"
              placeholder="Density (g or ml)"
              formControlName="density"
              [control]="productProjectForm.controls['density']"
              [submitted]="submitted"
              [maxLength]="50"
              inputType="number"
              [preventNegative]="true"
              (customBlur)="saveData($event)"
              [errorMessages]="{
                greaterThanZero: 'Density must be greater than 0.'
              }"
            ></piqet-angular-common-input>
          </div>
        </div>

        <div class="col-md-6 country-drp">
          <div class="text-icon-align d-flex">
            <p style="margin-bottom: 2px">Country</p>
          </div>
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            class="personalInputFiled"
            #select
            [items]="countryList"
            [searchable]="false"
            formControlName="country"
            bindLabel="name"
            [searchFn]="commonInputSearch"
            placeholder="Country*"
            (change)="saveData($event, 'isDrpDwn')"
            [readonly]="countryList?.length <= 1"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  type="text"
                  class="form-control accordion-search search-input"
                  id="inputValidation"
                  placeholder="Search..."
                  (input)="select.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>

          <div
            *ngIf="
              productProjectForm.controls['country'].touched &&
              productProjectForm.controls['country'].errors
            "
          >
            <div
              *ngIf="productProjectForm.controls['country'].errors?.['required']"
              class="input-error"
            >
              Country is required.
            </div>
          </div>
        </div>
      </div>

      <div class="row pb-3">
        <div class="col-sm-4">
          <div class="d-flex w-100 justify-content-between align-items-center checkboxview">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  type="checkbox"
                  class="chkOverview"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="isCostTurnedOff"
                  (change)="costTurnOff($event)"
                />
              </div>
              <div><span class="checkbox-style switch-cost">Switch on cost</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="showCurrencyList">
        <div class="col-sm-6 currencyTab">
          <div class="project-spacing currency-drpdown">
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              #currency
              [items]="currencyList"
              (change)="selectCurrency($event)"
              [searchable]="false"
              bindLabel="name"
              formControlName="currency"
              [searchFn]="commonInputSearch"
              placeholder="Currency"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="currency.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="row pt-3">
        <piqet-angular-file-upload
          type="image"
          [customConfig]="{
            selectButtonText: 'Select file',
            changeButtonText: 'Change',
            removeButtonText: 'Remove',
            placeholderText: 'Product image',
            acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
            acceptAttribute: '.png,.jpg,.jpeg,.gif',
            maxFileSize: 5,
            showPreview: true,
            customErrorMessage: 'Only .jpg,.png,.jpeg file allowed'
          }"
          [existingFileUrl]="productImage"
          [existingFileName]="existingFileName"
          (fileSelected)="onFileSelected($event)"
          (removeConfirmation)="handleRemoveConfirmation()"
          #fileUploadComponent
          customClass="col-sm-6 form-group"
        >
        </piqet-angular-file-upload>
      </div>

      <div class="row">
        <div class="col-12">
          <label class="subTitleName">Product scope</label>
        </div>

        <div class="d-flex pb-3 col-8 productScope">
          <ng-container *ngFor="let item of productScope; let i = index">
            <div class="d-flex checkBoxAlienMent">
              <span
                [ngbTooltip]="
                  isIngredientScope(item) ? 'Ingredients is mandatory and cannot be unchecked' : ''
                "
                placement="top"
                tooltipClass="sku-tooltip"
                container="body"
              >
                <input
                  type="checkbox"
                  id="{{ item.scopeId }}_{{ item.projectScopeTypeId }}"
                  class="chkOverview projectScopeChecks"
                  [checked]="item.checked"
                  [disabled]="isIngredientScope(item)"
                  (change)="selectedProductScope($event, item)"
                />
              </span>
              <div>
                <span class="checkbox-style" [class.disabled-text]="isIngredientScope(item)">{{
                  item.scopeName
                }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="row upper-custom-margin">
        <div class="form-group">
          <div class="services-form">
            <textarea
              formControlName="description"
              cols="20"
              (change)="saveData($event)"
              id="Description"
              name="Description"
              rows="2"
              placeholder="Description"
            ></textarea>
            <label>Description</label>
          </div>
        </div>
      </div>
    </form>
    <div class="modal-footer mt-4 justify-content-start" (click)="nextRoute()">
      <button type="button" class="next-btn modelBtn">
        Next<i class="bi bi-arrow-right checkbox-div"></i>
      </button>
    </div>
  </ng-container>
</div>
